import { Fragment } from "react";
const FastEasy = ({ text, h1, h2 }) => {
  return (
    <div className="fast-easy">
      <h2>{h1}</h2>
      <h3>{h2}</h3>
      <div className="wrapper">
        {text &&
          text.map((t, i) => (
            <Fragment key={i}>
              <div className="fast-box">
                <div className="shield-box">{i + 1}</div>
                <p className="orange">{t.h}</p>
                <p>{t.p}</p>
              </div>
              {i !== 2 ? <div className="arrow"></div> : null}
            </Fragment>
          ))}
      </div>
    </div>
  );
};

export default FastEasy;
